import useIsMobile from '@/hooks/use-is-mobile';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { Drawer, DrawerContent, DrawerTitle } from '../ui/drawer';

const SuccessDialog = (props: { open: boolean; isPlanning: boolean; onOpenChange: (nextOpen: boolean) => void }) => {
  const isMobile = useIsMobile();
  const { open, onOpenChange, isPlanning } = props;

  const content = (
    <div className='pb-10 pt-2.5 lg_flex lg_p-0'>
      <div className='flex justify-end pr-2.5 lg_hidden'>
        <button
          type='button'
          onClick={() => {
            onOpenChange(false);
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='22'
            height='22'
            fill='none'
            viewBox='0 0 22 22'
          >
            <path
              stroke='#80583F'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='M19 19 3 3m16 0L3 19'
            ></path>
          </svg>
        </button>
      </div>
      <div className='mt-3 flex justify-center lg_mt-0 lg_flex-none lg_p-[30px]'>
        <img
          src={process.env.NEXT_PUBLIC_BASE_PATH + '/images/just-said-yes/success-cover.webp'}
          width={320}
          height={427}
          alt=''
          className='h-auto w-full max-w-[260px] lg_max-w-[320px]'
        />
      </div>
      <div className='mt-[22px] lg_mt-0 lg_flex lg_flex-1 lg_flex-col lg_bg-f8f3ef lg_pt-4'>
        <div className='hidden justify-end pr-4 lg_flex lg_flex-none'>
          <button
            type='button'
            onClick={() => {
              onOpenChange(false);
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='22'
              height='22'
              fill='none'
              viewBox='0 0 22 22'
            >
              <path
                stroke='#80583F'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.5'
                d='M19 19 3 3m16 0L3 19'
              ></path>
            </svg>
          </button>
        </div>
        <div className='lg_flex lg_flex-1 lg_flex-col lg_justify-center lg_pb-4'>
          <div className=' text-center text-[15px] font-medium leading-[1.4] text-black lg_text-[20px] lg_leading-[1.2]'>
            Submission completely.
          </div>
          <div className='mt-1 text-center text-[13px] leading-[1.4] text-black lg_mt-2.5 lg_text-[17px]'>
            {isPlanning ? '12% Off Code Sitewide: WEDDING2026' : '10% Off Code Sitewide: ENGAGEMENT'}
          </div>
          <button
            type='button'
            onClick={() => {
              onOpenChange(false);
            }}
            className='mx-auto mt-5 flex h-10 min-w-[200px] items-center justify-center rounded-[3px] border-1 border-solid border-80583F bg-80583F px-1 text-center text-white lg_mt-10 lg_h-12 lg_min-w-[250px] lg_hover_bg-transparent lg_hover_text-80583F'
          >
            OKEY
          </button>
        </div>
      </div>
    </div>
  );

  return isMobile ? (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      handleOnly
    >
      <DrawerContent className='fixed bottom-0 left-0 z-[400] max-h-full w-full overflow-auto bg-white'>
        <DrawerTitle className='hidden'>Submission completely.</DrawerTitle>
        {content}
      </DrawerContent>
    </Drawer>
  ) : (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        showCloseButton={false}
        className='block max-h-full w-full max-w-[750px] overflow-auto border-none p-0 outline-0'
      >
        <DialogTitle className='hidden'>Submission completely.</DialogTitle>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
